import Component from './TwitterAnalyticsPublic.vue'
export default Component
